import { FaDoorOpen } from 'react-icons/fa';
import { useTempEdgeTranslator } from '../../../Hooks/useTranslation';

const SignOutButton = ({ className, onClick, testId }) => {
  const { tempedgeTranslator } = useTempEdgeTranslator();

  return (
    <button type="button" className={`te-signout-btn ${className}`} onClick={onClick} data-testid={testId}>
      <span>{tempedgeTranslator('com.tempedge.msg.label.signout')}</span>
      <FaDoorOpen size={14} />
    </button>
  );
};

export default SignOutButton;
